<template lang="html">
  <div class="user-info--inner">
    <info-wallet class="user-details-contents__items"></info-wallet>
    <info-memo class="user-details-contents__items"></info-memo>
  </div>
</template>

<script>
//= components
import Modal from '@/components/base/Modal'
import InfoWallet from '@/components/common/user-details/InfoWallet'
import InfoMemo from '@/components/common/user-details/InfoMemo'

export default {
  name: 'user-info',

  components: {
    Modal,
    InfoWallet,
    InfoMemo
  }
}
</script>
